module.exports = __webpack_public_path__ + "img/image9.68f7ff5a.png";